// extracted by mini-css-extract-plugin
export default {"container":"AuthNav_container__Ot1lf"};